<template>
	<div class="wx-pay-box" v-title data-title="微信支付">
		<div class="wx-pay-nav">
			<div class="fl ml-5 mt-1">
				<svg t="1725333057711" class="icon" viewBox="0 0 1024 1024" version="1.1"
					xmlns="http://www.w3.org/2000/svg" p-id="9665" width="60" height="60">
					<path
						d="M390.21952 631.09248c-61.26464 34.01984-70.35136-19.09888-70.35136-19.09888l-76.78208-178.46656c-29.54368-84.80512 25.56928-38.23744 25.56928-38.23744s47.2896 35.63392 83.17952 57.34784c35.87072 21.71392 76.75776 6.3744 76.75776 6.3744l501.9648-230.7776C837.94688 113.4528 684.96256 38.4 511.76576 38.4 229.11104 38.4 0 238.13248 0 484.52864c0 141.72544 75.8656 267.8656 194.0352 349.62176l-21.31072 122.01856c0 0-10.38848 35.6224 25.61536 19.10016 24.53376-11.26528 87.0784-51.63392 124.30976-76.20224 58.53056 20.31616 122.2976 31.5968 189.14432 31.5968 282.63168 0 511.79008-199.73248 511.79008-446.13376 0-71.36896-19.31008-138.76864-53.51552-198.59456C810.14144 381.7792 438.15808 604.51712 390.21952 631.09248L390.21952 631.09248 390.21952 631.09248zM390.21952 631.09248"
						fill="#05af10" p-id="9666"></path>
				</svg>
			</div>
			<div class="fl wx-font">
							<p><b class="wx-zh">微信支付</b></p>
							<p>WeChat Pay</p>
						</div>
		</div>
		<div class="whitebox py-1">
			<div class="wx-pay-content">
			<div class="mb-5 font-weight">
				<el-row>
					<el-col :span="12">订单编号：<span>{{wxpayData.id}}</span></el-col>
					<el-col :span="12" class="text-right">订单内容：产业研究大脑 - <span>{{wxpayData.title}} &nbsp;&nbsp;&nbsp;&nbsp; {{wxpayData.years}}年使用时长</span></el-col>
				</el-row>
				<el-row class="mt-1">
					<el-col :span="12">订单金额：<span>￥{{wxpayData.price}}</span></el-col>
					<el-col :span="12" class="text-right">订单状态：<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;未支付</span></el-col>
				</el-row>
			</div>
			<div class="wx-bg-white">
				<div class="wx-pay-title text-center">
					<div class="font-box oh">
						<div class=" fl mt-1">
							<svg t="1725329786111" class="icon" viewBox="0 0 1024 1024" version="1.1"
								xmlns="http://www.w3.org/2000/svg" p-id="11276" width="60" height="60">
								<path
									d="M395.846 603.585c-3.921 1.98-7.936 2.925-12.81 2.925-10.9 0-19.791-5.85-24.764-14.625l-2.006-3.864-78.106-167.913c-0.956-1.98-0.956-3.865-0.956-5.845 0-7.83 5.928-13.68 13.863-13.68 2.965 0 5.928 0.944 8.893 2.924l91.965 64.43c6.884 3.864 14.82 6.79 23.708 6.79 4.972 0 9.85-0.945 14.822-2.926L861.71 282.479c-77.149-89.804-204.684-148.384-349.135-148.384-235.371 0-427.242 157.158-427.242 351.294 0 105.368 57.361 201.017 147.323 265.447 6.88 4.905 11.852 13.68 11.852 22.45 0 2.925-0.957 5.85-2.006 8.775-6.881 26.318-18.831 69.334-18.831 71.223-0.958 2.92-2.013 6.79-2.013 10.75 0 7.83 5.929 13.68 13.865 13.68 2.963 0 5.928-0.944 7.935-2.925l92.922-53.674c6.885-3.87 14.82-6.794 22.756-6.794 3.916 0 8.889 0.944 12.81 1.98 43.496 12.644 91.012 19.53 139.48 19.53 235.372 0 427.24-157.158 427.24-351.294 0-58.58-17.78-114.143-48.467-163.003l-491.39 280.07-2.963 1.98z"
									fill="#ffffff" p-id="11277"></path>
							</svg>
						</div>
						<div class="fl color-fff wx-font">
							<p class="text-white"><b class="wx-zh">微信支付</b></p>
							<p class="text-white">WeChat Pay</p>
						</div>
					</div>
					<div>
						<div class="text-center wx-pay-code">
							<div class="mt-5 font-weight">微信扫码付款</div>
							<div class="redfont font-weight font-24 mt-1">￥{{wxpayData.price}}</div>
							<!-- <img src="../../assets/gongzhonghaoCode.jpg" alt=""> -->
							<embed :src="qrCode" width="280" height="280" type="image/svg+xml" />
							<div class="">
								<div class="fl ml-3">
									<svg t="1725331613348" class="icon" viewBox="0 0 1024 1024" version="1.1"
										xmlns="http://www.w3.org/2000/svg" p-id="14375" width="45" height="45">
										<path
											d="M928.016126 543.908618 95.983874 543.908618c-17.717453 0-31.994625-14.277171-31.994625-31.994625S78.26642 479.919368 95.983874 479.919368l832.032253 0c17.717453 0 31.994625 14.277171 31.994625 31.994625S945.73358 543.908618 928.016126 543.908618z"
											fill="#efb336" p-id="14376"></path>
										<path
											d="M832.032253 928.016126 639.892491 928.016126c-17.717453 0-31.994625-14.277171-31.994625-31.994625s14.277171-31.994625 31.994625-31.994625l191.967747 0c17.717453 0 31.994625-14.277171 31.994625-31.994625l0-159.973123c0-17.717453 14.277171-31.994625 31.994625-31.994625s31.994625 14.277171 31.994625 31.994625l0 159.973123C928.016126 884.840585 884.840585 928.016126 832.032253 928.016126z"
											fill="#efb336" p-id="14377"></path>
										<path
											d="M351.94087 928.016126l-159.973123 0c-52.980346 0-95.983874-43.003528-95.983874-95.983874l0-159.973123c0-17.717453 14.277171-31.994625 31.994625-31.994625S159.973123 654.341676 159.973123 672.05913l0 159.973123c0 17.717453 14.449185 31.994625 31.994625 31.994625l159.973123 0c17.717453 0 31.994625 14.277171 31.994625 31.994625C383.935495 913.738955 369.658324 928.016126 351.94087 928.016126z"
											fill="#efb336" p-id="14378"></path>
										<path
											d="M127.978498 383.935495c-17.717453 0-31.994625-14.277171-31.994625-31.994625l0-159.973123c0-52.980346 43.003528-95.983874 95.983874-95.983874l159.973123 0c17.717453 0 31.994625 14.277171 31.994625 31.994625S369.658324 159.973123 351.94087 159.973123l-159.973123 0c-17.545439 0-31.994625 14.449185-31.994625 31.994625l0 159.973123C159.973123 369.658324 145.695952 383.935495 127.978498 383.935495z"
											fill="#efb336" p-id="14379"></path>
										<path
											d="M896.021502 383.935495c-17.717453 0-31.994625-14.277171-31.994625-31.994625l0-159.973123c0-17.545439-14.277171-31.994625-31.994625-31.994625L639.892491 159.973123c-17.717453 0-31.994625-14.277171-31.994625-31.994625s14.277171-31.994625 31.994625-31.994625l191.967747 0c52.980346 0 95.983874 43.003528 95.983874 95.983874l0 159.973123C928.016126 369.658324 913.738955 383.935495 896.021502 383.935495z"
											fill="#efb336" p-id="14380"></path>
									</svg>
								</div>
								<div class="fl ml-1">请使用手机微信扫描<br>二维码以继续付款</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		</div>
		

	</div>
</template>

<script>
import { timers } from 'jquery';

// import { mapState, mapMutations, mapGetters } from "vuex";

export default {
	name: 'wxPay',
	// computed: {
	// 	...mapState({
	// 		isCollapse: (state) => state.isCollapse,
	// 	}),
	// 	...mapGetters(['isCollapse'])
	// },
	data() {
		return {
			wxpayData:{},
			qrCode:'',
			intervalId:null,//存定时器
			test:0,
		}
	},
	beforeCreate() {

	},
	created() {

	},
	beforeDestroy() { //页面销毁时清空定时器，避免反复执行
		// clearInterval(this.intervalId); // 清除定时器
	},

	mounted() {
		this.getWxpayData();
	},
	methods: {
		
			//获取微信订单信息code等
			getWxpayData() {
			var _this = this;
			var ajaxurl = this.$api.free.wxpay.pay()+"?id="+this.$route.query.id;
			this.$axios.get(ajaxurl).then(function (res) {
				if (res.data.success) {
					// console.log('微信订单详情', res);
					_this.wxpayData = res.data.data;
					_this.qrCode = _this.$api.free.wxpay.QRCode()+"?data="+_this.wxpayData.qrcodeData;

				} else {

				}
			}).catch(function (error) {
				// 请求失败处理 console.log(error);
			});
		},
		//获取二维码
		getQRcode(){
			// this.$axios.get(ajaxurl).then(function (res) {
			// 	if (res.data.success) {
			// 		console.log('二维码', res);
			// 	} else {

			// 	}
			// }).catch(function (error) {
			// 	// 请求失败处理 console.log(error);
			// });
		}
	}
}
</script>

<style lang="scss" scoped>
.wx-pay-nav {
	width: 100%;
	height: 80px;
	background-color: #fff;
	border-bottom: 3px solid #eee;
}

.wx-pay-content {
	width: 800px;
	height: auto;
	margin: 50px auto;
	padding-bottom: 60px;
}

.wx-bg-white {
	background: #fff;
	width: 100%;
	height: 550px;
	border-radius: 8px;
	box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.2);
}

.wx-font {
	margin-top: 18px;
	margin-left: 10px;
}

.wx-pay-title {
	width: 100%;
	height: 80px;
	background-color: #06c05f;
	border-radius: 8px 8px 0 0;

	.font-box {
		width: 186px;
		margin: 0 auto;
	}

	
}
.wx-zh {
		font-size: 20px;
		letter-spacing: 3px;
	}
.color-fff {
	color: #fff;
}

.wx-pay-code {
	width: 244px;
	// height: 230px;
	margin: auto;

	img {
		width: 100%;
		height: 100%;
	}
}
</style>
